
// import './polyfill';//'./polyfill.js';
// import "react-app-polyfill/ie11";
// import "react-app-polyfill/stable";
// import React from 'react';
// import ReactDOM from 'react-dom';
// import store from './store';
// // import { createStore, combineReducers, applyMiddleware } from 'redux';
// import { Provider } from 'react-redux';
// import Routes from './Global/Routes';
// import './i18n';
// // import GridFilterReducer from './store/reducer/GridFilterReducer';
// import * as serviceWorker from './serviceWorker';

// // import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// ReactDOM.render(
//   // <ClearCacheProvider auto={true}>
//     <Provider store={store}>
//       <Routes />
//     </Provider>
//   // </ClearCacheProvider>
//   ,
//   document.getElementById('root')
// );



// serviceWorker.register({
//   onUpdate: registration => {
//     if (window.confirm('A new update is available. Reload now to get the latest version')) {
//       registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
//       window.location.reload();
//     }
//   }
// });


import './polyfill';//'./polyfill.js';
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import store from './store';
// import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
// import thunk from 'redux-thunk';
// import { ClearCacheProvider, useClearCacheCtx } from 'react-clear-cache';
// import reducer from './store/reducer/reducer';
// import commonReducer from './store/reducer/commonReducer';
// import FileImportReducer from './store/reducer/FileImportReducer';
// import ProfileReducer from './store/reducer/ProfileReducer';
// import formBuilderReducer from './store/reducer/formBuilderReducer';
import Routes from './Global/Routes';
import './i18n';
// import GridFilterReducer from './store/reducer/GridFilterReducer';
import * as serviceWorker from './serviceWorker';
import VersionUpdateModal from './VersionUpdateModal';
import {broadcastReload,listenForReloadSignal } from './broadcastReload';


const App = () => {
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    listenForReloadSignal();
    serviceWorker.register({
      onUpdate: registration => {
        setShowUpdateModal(true);
        setWaitingWorker(registration.waiting);
      }
    });
  }, []);

  const handleReload = () => {
    // if (waitingWorker) {
      // waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      // waitingWorker.addEventListener('statechange', e => {
      //   if (e.target.state === 'activated') {
          broadcastReload();
          window.location.reload();
          
        // }
      // });
    // }
  };

  return (
    <Provider store={store}>
      <Routes />
      <VersionUpdateModal
        isOpen={showUpdateModal}
        onConfirm={handleReload}
        onCancel={() => setShowUpdateModal(false)}
      />
    </Provider>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));